import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaTachometerAlt, FaUserGraduate, FaUserPlus, FaBook, FaSignOutAlt } from 'react-icons/fa';
import './sidebar.css';
import img from "../../assets/images.png";
import logo from "../../assets/llogo.png";
import hr from "../../assets/hr.png";

const Sidebar = ({ onLogout }) => {
  const role = localStorage.getItem('role'); // Get user role

  return (
    <div className="sidebar" style={{ overflow: "auto" }}>
      <div className='d-flex'>
        <div>
          <img src={logo} width={50} height={50} alt="Logo" />
        </div>
        <div className='d-flex align-items-center'>
          <h6>Fazo Academy</h6>
        </div>
      </div>

      <div className='image-container mt-5'>
        <img src={hr} width={50} height={50} style={{ borderRadius: "50%" }} alt="HR" />
        <p>{role === 'admin' ? 'Management' : 'User'}</p>
      </div>

      <ul>
        <li>
          <NavLink to="/dashboard" activeClassName="active-link">
            <FaTachometerAlt className="icon" /> Dashboard
          </NavLink>
        </li>

        {role === 'admin' && (
          <>
            <li>
              <NavLink to="/student" activeClassName="active-link">
                <FaUserGraduate className="icon" /> Student List
              </NavLink>
            </li>
            <li>
              <NavLink to="/studentadd" activeClassName="active-link">
                <FaUserPlus className="icon" /> Student Add
              </NavLink>
            </li>
            <li>
              <NavLink to="/jobassits" activeClassName="active-link">
                <FaUserPlus className="icon" /> Job Assist
              </NavLink>
            </li>
            <li>
              <NavLink to="/course" activeClassName="active-link">
                <FaBook className="icon" /> Course
              </NavLink>
            </li>
            <li>
              <NavLink to="/mentor" activeClassName="active-link">
                <FaBook className="icon" /> Mentor
              </NavLink>
            </li>
            <li>
              <NavLink to="/invoice" activeClassName="active-link">
                <FaBook className="icon" /> Invoice
              </NavLink>
            </li>
            <li>
              <NavLink to="/intern" activeClassName="active-link">
                <FaBook className="icon" /> Internship
              </NavLink>
            </li>
            {/* <li>
              <NavLink to="/career" activeClassName="active-link">
                <FaBook className="icon" /> Job Post for Triplette
              </NavLink>
            </li> */}
          </>
        )}

        {/* Shared by both roles */}
        <li>
          <NavLink to="/enquiry" activeClassName="active-link">
            <FaBook className="icon" /> Enquiry Form
          </NavLink>
        </li>

        <li>
          <NavLink to="/career" activeClassName="active-link">
            <FaBook className="icon" /> Job Post for Triplette and Redite
          </NavLink>
        </li>
      </ul>

      <div style={{ padding: '10px' }}>
        <button
          onClick={onLogout}
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#ff4d4d',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            marginTop: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            cursor: 'pointer'
          }}
        >
          <FaSignOutAlt /> Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
